// No imports by design: src/index.js (the entry chunk) applies the stored theme
// before first paint, and routing through services/localStorage would drag
// crypto-js onto the boot path to read one string.

export const THEME_DARK = "dark";
export const THEME_LIGHT = "light";

const APP_THEME_STORAGE_KEY = "appTheme";

/** What the design system reads to swap its tokens. Only this module sets it. */
const DARK_BODY_CLASS = "dark";

/** JSON-encoded to match the shared getJsonItem/setJsonItem helpers. */
const readStoredTheme = () => {
  try {
    return JSON.parse(localStorage.getItem(APP_THEME_STORAGE_KEY));
  } catch (err) {
    console.error(err);
    return null;
  }
};

const writeStoredTheme = theme => {
  try {
    localStorage.setItem(APP_THEME_STORAGE_KEY, JSON.stringify(theme));
  } catch (err) {
    console.error(err);
  }
};

/**
 * Not gated by `FeatureFlag:EnableThemeSwitcher` — hiding the switcher must not
 * revert a user who opted into dark. With the flag off, the stored choice can
 * only be cleared from localStorage.
 *
 * @returns {"dark" | "light"}
 */
export const getGlobalTheme = () =>
  readStoredTheme() === THEME_DARK ? THEME_DARK : THEME_LIGHT;

/** Applies `theme` to <body> without persisting it. */
export const applyThemeToBody = theme => {
  if (typeof document === "undefined" || !document.body) {
    return;
  }
  document.body.classList.toggle(DARK_BODY_CLASS, theme === THEME_DARK);
};

/** Persists `theme` and applies it without a reload. */
export const setGlobalTheme = theme => {
  writeStoredTheme(theme);
  applyThemeToBody(theme);
};

/** Replays the persisted theme. Safe to call before React mounts. */
export const applyStoredTheme = () => {
  applyThemeToBody(getGlobalTheme());
};
